import React, { useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { usePage } from '../context/PageContext';
import Dashboard from '../pages/Dashboard/Dashboard';
import Dummy from '../pages/Dummy.js';
// import VoiceAnalyticsTranscriptionDetails from '../components/CallDetails/CallDetails.js';
// import AuditPresetTemplate from '../components/ParameterDashboard/ParameterDashboard.js';
import AddUser from '../components/UserManagement/AddUser.js';
// import UploadData from '../components/UploadData/UploadData.js';
// import AuditReport from '../components/AuditReport/AuditReport.js';
import NotFound from '../pages/NotFound/NotFound.js';
import { checkPermission } from '../utilities/hasPermission.js';
import UserList from '../components/UserManagement/UserList.js';
import LogHistory from '../components/LogHistory/LogHistory.js';
import CompanyList from '../components/AdminPannel/CompanyList.js';
import Campaigns from '../components/Campaigns/Campaigns.js';
import AllLeads from '../components/leads/AllLeads.js';
import CompanyDashboard from '../components/AdminPannel/CompanyDashboard.js';
import IVRInitializeCall from '../pages/IVR/IVRInitializeCall.js';
import ScriptList from '../components/AdminPannel/ScriptList.js';
import CallNumbersList from '../components/AdminPannel/CallNumbersList.js';
import AllCalls from '../components/leads/AllCalls.js';
import ChatPage from '../pages/ChatPage/ChatPage.js';
import AgentAssist from '../pages/ChatPage/AgentAssist.js';
import DispositionList from '../components/AdminPannel/DispositionList.js';
import ScriptManagementContent from '../components/ScriptManagement/ScriptManagementContent.js';

// Page wrapper component to set page title
const PageWrapper = ({ title, children }) => {
  const { setPageTitle } = usePage();

  useEffect(() => {
    if (title) {
      setPageTitle(title);
      document.title = `${title} | AI Bot UI`;
    }
  }, [title, setPageTitle]);

  return children;
};

const ProtectedRoute = ({ component: Component, permission, title, ...rest }) => {
  const isAllowed = !permission || checkPermission.hasPermission(Array.isArray(permission) ? permission : [permission]);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAllowed ? (
          <PageWrapper title={title}>
            <Component {...props} />
          </PageWrapper>
        ) : (
          <Redirect to="/not-authorized" />
        )
      }
    />
  );
};

export default function RouterPage() {
  const location = useLocation();
  const { setPageTitle } = usePage();

  // Set default title for unknown routes
  useEffect(() => {
    if (location.pathname === '/') {
      setPageTitle('Dashboard');
      document.title = 'Dashboard | AI Bot UI';
    }
  }, [location, setPageTitle]);

  return (
    <Switch>
      <Route path="/test" exact><PageWrapper title="Test Page"><Dummy /></PageWrapper></Route>
      <ProtectedRoute path="/dashboard" exact component={Dashboard} permission="ivr:sidebar_dashboard" title="Dashboard" />
      {/* <ProtectedRoute path="/transcription-details" exact component={VoiceAnalyticsTranscriptionDetails} permission="ivr:sidebar_transcription" title="Transcription Details" /> */}
      {/* <ProtectedRoute path="/audit-report" exact component={AuditReport} permission="ivr:sidebar_audit_report" title="Audit Report" /> */}
      {/* <ProtectedRoute path="/upload-data" exact component={UploadData} permission="ivr:sidebar_upload_data" title="Upload Data" /> */}
      {/* <ProtectedRoute path="/parameter-config" exact component={AuditPresetTemplate} permission="ivr:sidebar_parameter_config" title="Parameter Config" /> */}
      <ProtectedRoute path="/add-user" exact component={AddUser} permission="ivr:sidebar_add_user" title="Add User" />
      <ProtectedRoute path="/user-list" exact component={UserList} permission="ivr:sidebar_user_list" title="User List" />
      <ProtectedRoute path="/add-company" exact component={CompanyList} permission="ivr:sidebar_add_company" title="Add Company" />
      <ProtectedRoute path="/campaigns" exact component={Campaigns} permission="ivr:sidebar_campaigns" title="Campaigns" />
      <ProtectedRoute path="/log-history" exact component={LogHistory} permission="ivr:log_history" title="Log History" />
      <ProtectedRoute path="/leads" exact component={AllLeads} permission="ivr:sidebar_leads" title="Leads" />
      <ProtectedRoute path="/company-list" exact component={CompanyDashboard}  permission="ivr:sidebar_company_list" title="Company list" />
      <ProtectedRoute path="/script-resource" exact component={ScriptManagementContent} permission="ivr:sidebar_script_resource" title="Script/Resource" />
      <ProtectedRoute path="/call-numbers" exact component={CallNumbersList} permission="ivr:sidebar_numbers_list"  title="Call Numbers" />
      <ProtectedRoute path="/disposition-list" exact component={DispositionList} permission="ivr:sidebar_disposition_list"  title="Disposition" />
      <ProtectedRoute path="/initialize-call" exact component={IVRInitializeCall} permission="ivr:sidebar_initialize_call"  title="Initialize Call" />
      <ProtectedRoute path="/calls" exact component={AllCalls}  permission="ivr:sidebar_calls"  title="Calls" />
      <ProtectedRoute path="/client-assist" exact component={ChatPage}  permission="ivr:sidebar_ai_assistant"  title="Client Assist" />
      <ProtectedRoute path="/agent-assist" exact component={AgentAssist}  permission="ivr:sidebar_ai_assistant"  title="Agent Assist" />

      <Route path="*"><PageWrapper title="Page Not Found"><NotFound /></PageWrapper></Route>
    </Switch>

  );
}
